import { isNil } from 'lodash';
import { type GenerateDEMInputType } from './types';

export const generateDEMValidator = (
  name: string,
  values: Partial<GenerateDEMInputType>,
): string => {
  switch (name) {
    case 'outputResolution':
      const outputResolution = values.outputResolution;

      if (isNil(outputResolution)) {
        return 'This field is required.';
      }

      if (outputResolution > 5 || outputResolution <= 0) {
        return 'Please enter a value between 0.1 and 5 meters.';
      }

      return '';

    default:
      return '';
  }
};
